/**
 * @brief 症状カード画面 
 * @author S.Yamada
 * @date 2020.11.3
 */

import React, {useEffect, useState }   from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
//import { withRouter }   from "react-router";
import { ListGroup }    from 'react-bootstrap';
import Button           from '@material-ui/core/Button';
import Grid             from '@material-ui/core/Grid'
import Toolbar          from '@material-ui/core/Toolbar';
//import IconButton       from '@material-ui/core/IconButton';
//import Tooltip          from '@material-ui/core/Tooltip';
//import KeyReturnIcon    from '@material-ui/icons/KeyboardReturn';
import { makeStyles, createStyles }   from '@material-ui/core/styles';
import Modal            from '@material-ui/core/Modal';
import Fade             from '@material-ui/core/Fade';
import AppBar           from '@material-ui/core/AppBar';
import queryString      from 'query-string'
import FamikarHeader    from '../components/FamikarHeader';
import ModalInterview   from '../components/ModalInterview';
import ModalFollowUp    from '../components/ModalFollowUp';
import ModalDiagnosis   from '../components/ModalDiagnosis';
import ModalMedicine    from '../components/ModalMedicine';
import VariousRecord    from "../components/VariousRecord";
import ModalFamilyView  from "../components/ModalFamilyView";
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase         from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import DiagnosisImg     from '../img/doctor.svg'
import FollowupImg      from '../img/chart_line.svg'
import MedicineImg      from '../img/medicines.svg'
//import { useNavigate } from "react-router";

const useStyles = makeStyles((theme) => createStyles ({
  root: {
    width: '100%',
  },
  container: {
    fontSize: 10,
  },
  float:{
    position: 'fixed',
    top:      'auto',
    left:     'auto',
    bottom:   50,
    right:    50,
    padding:  5,
    width:    50,
    height:   50
  },
  modal: {
    maxHeight: '100%',
    overflowY: 'auto',
  },
  paper: {
    position: 'relative',
    display: 'block',
    top: '0',
    left: '50%',
    outline: 'none',
    transform: 'translate(calc(-50% - 0.5rem), 0)',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgba(0,0,0,.2)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3, 2, 3),
    margin: '1.75rem .5rem',
    maxWidth: '460px',
    width: 'calc(100% - 1rem)',
    borderRadius: '.3rem',
    overflowY: 'visible',
  },
}));

//経過情報一覧
const FollowupList = {
  list:[
    //{
    //  id:               "(文字列)",   // ドキュメントID
    //  Appetite:         "(文字列)",   // 食欲 「普段通り食べれている」、「普段の半分くらい食べれている」、「全く食べれていない」
    //  BodyTemperature:  "(数値)",     // 体温
    //  Moisture:         "(文字列)",   // 水分摂取 「普段通り取れている」、「普段の半分くらい取れている」、「全く取れていない」
    //  Mood:             "(文字列)",   // 機嫌 「機嫌が良い」、「機嫌がやや悪い」、「機嫌が悪い」
    //  RunnyNose:        "(文字列)",   // 鼻水の有無 「鼻水なし」、「鼻水がやや出ている」、「鼻水が出ている」
    //  Headache:         "(文字列)",   // 頭痛の有無 「頭痛なし」、「頭痛がやや出ている」、「頭痛が出ている」
    //  Diarrhea:         "(文字列)",   // 下痢の有無 「下痢なし」、「下痢がやや出ている」、「下痢が出ている」
    //  Vomit:            "(文字列)",   // 嘔吐の有無 「嘔吐なし」、「嘔吐がやや出ている」、「嘔吐が出ている」
    //  Phlegm:           "(文字列)",   // 痰の有無 「痰なし」、「痰がやや出ている」、「痰が出ている」
    //  BreathSounds:     "(文字列)",   // 呼吸音の有無 「呼吸音の異常なし」、「呼吸音にやや異常が出ている」、「呼吸音にあり」
    //  Stomachache:      "(文字列)",   // 腹痛の有無 「腹痛なし」、「腹痛がやや出ている」、「腹痛がある」
    //  Eruption:         "(文字列)",   // 発疹の有無 「発疹なし」、「発疹がやや出ている」、「発疹がある」
    //  Spasm:            "(文字列)",   // けいれんの有無 「けいれん なし」、「けいれん がやや出ている」、「けいれんがある」
    //  Note:             "(文字列)",   // メモ
    //  image_url:        "(文字列)",   // 経過記録画像URL
    //  thum_url:         "(文字列)",   // 経過記録サムネイル画像URL
    //  FollowUpTime:     "(日時)",     // 経過記録時刻
    //  UpdateTime:       "(日時)",     // 更新時刻
    //  CreateTime:       "(日時)",     // 作成時刻
    //  DeleteFlag:       "(ブール値)", // 削除フラグ
    //}
  ]
}

//診察結果一覧
const MedicalResultList = {
  list:[
    //{
    //  id:               "(文字列)",   // ドキュメントID
    //  ConsultationTime: "(日時)",     // 受診時刻
    //  HospitalName:     "(文字列)",   // 病院名
    //  MedicalSpecialty: "(文字列)",   // 診療科目
    //  DoctorName:       "(文字列)",   // 医者の名前
    //  Diagnosis:        "(文字列)",   // 診断結果
    //  Instructions:     "(文字列)",   // 医者の指示
    //  Note:             "(文字列)",   // メモ
    //  UpdateTime:       "(日時)",     // 更新時刻
    //  CreateTime:       "(日時)",     // 作製時刻
    //  DeleteFlag:       "(ブール値)", // 削除フラグ
    //}
  ]
}

//お薬情報一覧
const MedicineList = {
  list:[
    //{
    //  id:               "(文字列)",   // ドキュメントID
    //  title:            "(文字列)",   // 画像のタイトル
    //  alt:              "(文字列)",   // 画像代替テキスト
    //  text:             "(文字列)",   // 詳細説明テキスト
    //  image_url:        "(文字列)",   // 経過記録画像URL
    //  thum_url:         "(文字列)",   // 経過記録サムネイル画像URL
    //  received_date:    "(日時)",     // お薬を貰った日
    //  pharmacy:         "(文字列)",   // 調剤薬局名
    //  payment:          "(文字列)",   // 支払い金額
    //  Note:             "(文字列)",   // メモ
    //  UpdateTime:       "(日時)",     // 更新時刻
    //  CreateTime:       "(日時)",     // 作成時刻
    //}
  ]
}

/**
 * @brief 症状カード画面クラス
 */
export default function SymptomCard(props){
  const navigate = useNavigate()
  const location = useLocation()
  const { MedicalRecordID } = useParams()
  const classes = useStyles()
  // console.log('MedicalRecordID: ' + MedicalRecordID)
  // 症状カード画面で展開されるモーダルの種類を制御する処理
  let upModalShows = {
    'Interview':  false,
    'FollowUp':   false,
    'Diagnosis':  false,
    'Medicine':   false,
    'FamilyView': false,
  }

  const [ CreateTime,        setCreateTime        ] = useState((location.state !== null && location.state.record.CreateTime     !== '') ? location.state.record.CreateTime     : new Date()) //診療情報作成時刻
  const [ Diagnosis,         setDiagnosis         ] = useState((location.state !== null && location.state.Diagnosis             !== '') ? location.state.Diagnosis             : ''        ) //診断結果
  const [ DisplayName,       setDisplayName       ] = useState((location.state !== null && location.state.DisplayName           !== '') ? location.state.DisplayName           : ''        ) //診療情報登録対象の表示名
  const [ FamilyID,          setFamilyID          ] = useState((location.state !== null && location.state.FamilyID              !== '') ? location.state.FamilyID              : ''        ) //診療情報登録対象の家族ID
  const [ Fever_Degrees,     setFever_Degrees     ] = useState((location.state !== null && location.state.record.Fever_Degrees  !== '') ? location.state.record.Fever_Degrees  : ''        ) //発熱時の体温
  const [ First_FollowUp,    setFirst_FollowUp    ] = useState((location.state !== null && location.state.record.First_FollowUp !== '') ? location.state.record.First_FollowUp : ''        ) //初回経過情報参照先のドキュメントパス
  const [ HospitalName,      setHospitalName      ] = useState((location.state !== null && location.state.HospitalName          !== '') ? location.state.HospitalName          : ''        ) //病院名
  const [ isLogin,           setIsLogin           ] = useState(false) 
  const [ MemberID,          setMemberID          ] = useState((location.state !== null && location.state.MemberID              !== '') ? location.state.MemberID              : ''        ) //診療情報登録対象のメンバーID
  const [ Note,              setNote              ] = useState((location.state !== null && location.state.record.Note           !== '') ? location.state.record.Note           : ''        ) //フリーメモ
  const [ Member_url,        setMember_url        ] = useState((location.state !== null && location.state.member_url            !== '') ? location.state.member_url            : ''        ) //診療情報登録対象のアイコン画像パス
  const [ modalShows,        setmodalShows        ] = useState(upModalShows) //モーダル展開状況
  const [ record,            setRecord            ] = useState((location.state !== null && location.state.record                !== '') ? location.state.record                : ''        ) //診療情報
  const [ RecordTitle,       setRecordTitle       ] = useState((location.state !== null && location.state.record.Title          !== '') ? location.state.record.Title          : ''        ) //診療情報のタイトル
  const [ username,          setUsername          ] = useState('')
  const [ UpdateTime,        setUpdateTime        ] = useState((location.state !== null && location.state.record.UpdateTime     !== '') ? location.state.record.UpdateTime     : new Date()) //診療情報更新時刻
  const [ Uid,               setUid               ] = useState((location.state !== null && location.state.uid                   !== '') ? location.state.uid                   : ''        ) //ログインユーザーのuid
  const [ followupList,      setFollowupList      ] = useState([]) //経過情報リスト
  const [ medicalResultList, setMedicalResultList ] = useState([]) //診察結果リスト
  const [ medicineList,      setMedicineList      ] = useState([]) //お薬情報リスト

  useEffect(() => { //ページ表示時、情報更新時に実行
    // URLクエリを使用する
    var view = new URLSearchParams(location.search).get("view")
    // console.dir(view)
    console.dir(location.state)
    console.log("useEffect(): uid[" + Uid + "]")
    window.addEventListener('beforeunload', ()=>{
      console.log(document.location)
      //Promise.resolve().then(setTimeout(10000))
    })
    
    window.addEventListener('popstate', ()=>{
      if (document.location.pathname.split('/')[1] === "SymptomCard") { //ブラウザの戻る・進むボタンでの移動時にページの再読み込み実施
        window.location.reload();
      } 
    })

    const db = firebase.firestore()
    getLoginInfo(db).then(()=>{
      // 経過・診療・お薬情報を取ってくる
      if(followupList.length === 0 || medicalResultList.length === 0 || medicineList.length === 0) {
        getMedicalRecord(db)
      }
    })
    console.log("useEffect(): finish getMedicalRecord");
    if(view){ //URLにviewのパラメータがあるかを確認
      upModalShows[view] = true
      // console.log(view)
      // console.dir(upModalShows)
      // console.dir(props)
    }
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[navigate, location]);

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    window.removeEventListener('popstate', ()=>{})     //症状カード画面から離れる場合は、ブラウザの戻るボタンでの移動時のページ再読み込みは中止する
    window.removeEventListener('beforeunload', ()=>{}) //画面を抜ける際のイベント待機を終了する
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);

  console.log("uid: " + Uid)
  console.log("MemberID: " + MemberID)
  console.log("CreateTime: " + CreateTime)
  // console.log("Fever_Degrees: " + Fever_Degrees)
  // console.log("First_FollowUp: " + First_FollowUp)

  /**
   * ログイン情報取得
   */
  const getLoginInfo = (db) => {
    console.log("SymptomCard.js getLoginInfo()")
    return Promise.resolve().then(()=>{
      return new Promise((resolve)=>{
        firebase.auth().onAuthStateChanged((user)=>{ //現在ログインしているユーザーを取得する。
          if (user) {
            setUid((prevUid)=> (prevUid !== '' ? prevUid : user.uid))
            setIsLogin(true)
            resolve(user.uid)
          } else {
            setIsLogin(false)
            navigate('/') //ログインユーザー情報が取得できない場合は、アプリトップページに移動する
            resolve(null)
          }
        })
      })
    })
    .then((uid)=>{
      if(!uid){
        return null
      }
      return new Promise((resolve)=>{
        if (FamilyID === '') {
          db.collection("Person").doc(uid).get().then((Person_result)=>{ //ログインユーザー情報から、家族IDの情報を取得する
            const familyID = Person_result.data().FamilyID[0].id // 1件目の家族IDを取得する。
            setFamilyID(familyID)
            resolve(uid)
          })
        } else {
          resolve(uid)
        }
      })
    })
  }

  /**
   * 指定の症状の経過情報・診察結果・お薬情報の取得
   * @param {in} db 
   */
  const getMedicalRecord = async(db)=> {
    console.log('getMedicalRecord() start!!')
    await getFollowupList(db) //経過情報取得
  }

  /**
   * 指定の経過情報取得
   * @param {in} db
   */
  const getFollowupList = async(db) => {
    // 経過情報の取得
    await db.collection("MedicalRecords").doc(MedicalRecordID).collection("datas")
    .get().then(async(result) => {
      FollowupList.list = []
      console.log("SymptomCard.js get followupList");

      //  指定の症状の経過情報を保存
      result.forEach((doc)=>{
        const followup = doc.data();
        followup.id = doc.id //ドキュメントID追加
        FollowupList.list.push({
          id:              followup.id,              // ドキュメントID
          CreateTime:      followup.CreateTime,      // 作成日時
          UpdateTime:      followup.UpdateTime,      // 更新日時
          Note:            followup.Note,            // メモ
          BodyTemperature: followup.BodyTemperature, // 体温
          thum_url:        followup.thum_url,        // 経過記録サムネイル画像URL
          record:          followup.record,          // 診療情報
        })
        //console.log(`SymptomCard.js followup = ${JSON.stringify(followup,null,'\t')}`);
      })
      // console.log(`SymptomCard.js FollowupList = ${JSON.stringify(FollowupList.list,null,'\t')}`);
      await getMedicalResultList(db) //診察結果取得
    }).catch((error) => {
      console.log("Error getting followup list: ", error);
    });
  }
  /**
   * 指定の診察結果取得
   * @param {in} db
   */
  const getMedicalResultList = async(db) => {
    // 診察結果の取得
    await db.collection("MedicalRecords").doc(MedicalRecordID).collection("MedicalResults")
    .get().then(async(result) => {
      //console.log("SymptomCard.js get medicalResults");
      MedicalResultList.list = []
      //  指定の症状の診察結果を保存
      result.forEach((doc) => {
        const medicalResult = doc.data()
        medicalResult.id = doc.id //ドキュメントID追加
        MedicalResultList.list.push({
          id:               medicalResult.id,               // ドキュメントID
          Diagnosis:        medicalResult.Diagnosis,        // 診断結果
          Instructions:     medicalResult.Instructions,     // 医者の指示
          CreateTime:       medicalResult.CreateTime,       // 作成日時
          UpdateTime:       medicalResult.UpdateTime,       // 更新日時
          HospitalName:     medicalResult.HospitalName,     // 病院名
          MedicalSpecialty: medicalResult.MedicalSpecialty, // 診療科目
          Note:             medicalResult.Note,             // メモ
        })
        //console.log(`SymptomCard.js medicalResultList = ${JSON.stringify(medicalResult,null,'\t')}`);
      })
      //console.log(`SymptomCard.js medicalResultList = ${JSON.stringify(MedicalResultList.list,null,'\t')}`);
      await getMedicineList(db) //お薬情報取得
    }).catch((error) => {
      console.log("Error getting medicalResult list: ", error);
    })
  }

  /**
   * 指定の診察結果取得
   * @param {in} db
   */
  const getMedicineList = async(db) => {
    let uid            = '' // ログインユーザーuidを格納する
    let familyID       = '' // 家族ID
    let memberID       = '' // メンバーID
    let displayName    = '' // メンバー表示名
    let member_url     = '' // メンバー画像
    let diagnosis      = '' // 診断結果
    let recordTitle    = '' // 診療情報のタイトル
    let hospitalName   = '' // 医療機関名
    let createTime     = '' // 作成日時
    let updateTime     = '' // 更新日時
    let fever_Degrees  = 0  // 発熱時の体温
    let note           = '' // フリーメモ
    let first_FollowUp = '' // 初回経過情報を格納したドキュメントパス
    await Promise.resolve().then(()=>{
      return new Promise((resolve)=>{
        // お薬情報の取得
        db.collection("MedicalRecords").doc(MedicalRecordID).collection("Medicine")
        .get().then((result) => {
          //console.log("SymptomCard.js get Medicine");
          MedicineList.list = []
          result.forEach((doc) => {
            const medicine = doc.data();
            medicine.id = doc.id //ドキュメントIDを追加
            MedicineList.list.push(medicine);
            //console.log(`SymptomCard.js medicineList = ${JSON.stringify(medicine,null,'\t')}`);
            //console.log(`SymptomCard.js medicine : ${medicine}`);
            //console.log(`SymptomCard.js medicine doc.id : ${doc.id}`);
            //console.log(`SymptomCard.js medicine medicine.id : ${medicine.id}`);
            //console.log(`SymptomCard.js medicine.image_url : ${medicine.images[0].image_url}`);
          })
          resolve()
        })
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        if (Uid === '') {
          firebase.auth().onAuthStateChanged((user)=>{ //現在ログインしているユーザーを取得する。
            if (user) {
              uid = user.uid
              resolve()
            } else {
              // this.props.history.push({pathname: '/'}) //ログインユーザー情報が取得できない場合は、アプリトップページに移動する
              navigate('/') //ログインユーザー情報が取得できない場合は、アプリトップページに移動する
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        if (FamilyID === '') {
          db.collection("Person").doc(uid).get().then((Person_result)=>{ //ログインユーザー情報から、家族IDの情報を取得する
            familyID = Person_result.data().FamilyID[0].id // 1件目の家族IDを取得する。
            resolve()
          })
        } else {
          familyID = FamilyID
          resolve()
        }
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        if (MemberID === ''){
          if (MedicalRecordID !== '') { // 診療情報のレコードIDが存在することを確認する。
            memberID = MedicalRecordID.split('_')[0] // 診療情報のレコードIDから、「_」の前のメンバーIDを取り出す。
            resolve()
          } else {
            // this.props.history.push({pathname: '/'})
            navigate('/') //診療情報のレコードIDが無い場合は、アプリトップページに移動する
            resolve()
          }
        } else {
          memberID = MemberID
          resolve()
        }
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        if (DisplayName === '' || Member_url === '') {
          db.collection("Family").doc(familyID).collection("Member").doc(memberID).get().then((Member_result)=>{
            displayName = ((Member_result.data().DisplayName) ? Member_result.data().DisplayName : '')
            member_url  = ((Member_result.data().image_url  ) ? Member_result.data().image_url   : '')
            resolve()
          })
        } else {
          displayName = DisplayName
          member_url  = Member_url
          resolve()
        }
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        db.collection("MedicalRecords").doc(MedicalRecordID).get().then((Record_result)=>{
          diagnosis      = ((Record_result.data().Diagnosis                   ) ? Record_result.data().Diagnosis                    : '')
          recordTitle    = ((Record_result.data().Title                       ) ? Record_result.data().Title                        : '')
          hospitalName   = ((Record_result.data().HospitalName                ) ? Record_result.data().HospitalName                 : '')
          createTime     = ((Record_result.data().CreateTime                  ) ? Record_result.data().CreateTime.toDate()          : '')
          updateTime     = ((Record_result.data().UpdateTime                  ) ? Record_result.data().UpdateTime.toDate()          : '')
          first_FollowUp = ((Record_result.data().First_FollowUp              ) ? Record_result.data().First_FollowUp.path          : '')
          fever_Degrees  = ((Record_result.data().InterviewSheet.Fever_Degrees) ? Record_result.data().InterviewSheet.Fever_Degrees : '')
          note           = ((Record_result.data().InterviewSheet.Note         ) ? Record_result.data().InterviewSheet.Note          : '')
          //console.log('getMedicineList() get Fever_Degrees:' + Fever_Degrees)
          resolve()
        })
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        console.log('getMedicineList() 1 Fever_Degrees:' + Fever_Degrees + ', UpdateTime: ' + UpdateTime)
        setUid              ((uid           !== ''  ) ? uid           : Uid          ) // ログインユーザーID
        setFamilyID         ((familyID      !== ''  ) ? familyID      : FamilyID     ) // 家族ID
        setMemberID         ((memberID      !== ''  ) ? memberID      : MemberID     ) // メンバーID
        setDisplayName      ((displayName   !== ''  ) ? displayName   : DisplayName  ) // メンバー表示名
        setMember_url       ((member_url    !== ''  ) ? member_url    : Member_url   ) // メンバー画像
        setDiagnosis        ((diagnosis     !== ''  ) ? diagnosis     : Diagnosis    ) // 診断結果
        setRecordTitle      ((recordTitle   !== ''  ) ? recordTitle   : RecordTitle  ) // 診療情報のタイトル
        setHospitalName     ((hospitalName  !== ''  ) ? hospitalName  : HospitalName ) // 医療機関名
        setCreateTime       ((createTime    !== ''  ) ? createTime    : CreateTime   ) // 作成日時
        setUpdateTime       ((updateTime    !== ''  ) ? updateTime    : UpdateTime   ) // 更新日時
        setFirst_FollowUp   ((first_FollowUp!== ''  ) ? first_FollowUp: First_FollowUp) // 初回経過情報を格納したドキュメントパス
        setFever_Degrees    ((fever_Degrees !== ''  ) ? fever_Degrees : Fever_Degrees) // 発熱時の体温
        setNote             ((note          !== ''  ) ? note          : Note         ) // フリーメモ
        setFollowupList     ((FollowupList.list      !== null) ? FollowupList.list      : []            ) // 経過情報リスト
        setMedicalResultList((MedicalResultList.list !== null) ? MedicalResultList.list : []            ) // 診察結果リスト
        setMedicineList     ((MedicineList.list      !== null) ? MedicineList.list      : []            ) // お薬情報リスト
        // this.setState({
        //   uid:               (this.state.uid         !== '') ? this.state.uid         : uid,                    // ログインユーザーID
        //   FamilyID:          (this.state.FamilyID    !== '') ? this.state.FamilyID    : FamilyID,               // 家族ID
        //   MemberID:          (this.state.MemberID    !== '') ? this.state.MemberID    : MemberID,               // メンバーID
        //   DisplayName:       (this.state.DisplayName !== '') ? this.state.DisplayName : DisplayName,            // メンバー表示名
        //   member_url:        (this.state.member_url  !== '') ? this.state.member_url  : member_url,             // メンバーアイコン画像パス
        //   Diagnosis:         Diagnosis,              // 診断結果
        //   RecordTitle:       RecordTitle,            // 診療情報のタイトル
        //   hospitalName:      hospitalName,           // 医療機関名
        //   CreateTime:        CreateTime,             // 作成日時
        //   UpdateTime:        UpdateTime,             // 更新日時
        //   First_FollowUp:    First_FollowUp,         // 初回経過情報を格納したドキュメントパス
        //   Fever_Degrees:     Fever_Degrees,          // 発熱時の体温
        //   Note:              Note,                   // フリーメモ
        //   followupList:      FollowupList.list,      // 経過情報リスト
        //   medicalResultList: MedicalResultList.list, // 診察結果リスト
        //   medicineList:      MedicineList.list,      // お薬情報リスト
        // })
        resolve()
      })
    })
    .catch((error) => {
      console.log("Error getting medicine list: ", error)
    })
    //console.log(`SymptomCard.js medicineList = ${JSON.stringify(MedicineList.list,null,'\t')}`);
    //console.log(`SymptomCard.js followupList = ${followupList}`);
    //console.log(`SymptomCard.js medicalResultList = ${medicalResultList}`);
    //console.log(`SymptomCard.js medicineList = ${medicineList}`);
    //this.setState({followupList: followupList});
    //this.setState({medicalResultList: medicalResultList});
    //this.setState({medicineList: medicineList});
    
    //Storage内の経過情報画像を格納したフォルダ内のファイルとフォルダの一覧取得
    // firebase.storage().ref().child('member_data_image').listAll().then(function(res) {
    //  res.prefixes.forEach(function(folderRef) {
    //    // All the prefixes under listRef.
    //    console.log('folderRef: ' + folderRef)
    //  });
    //  res.items.forEach(function(itemRef) {
    //    // All the items under listRef.
    //    console.log('itemRef: ' + itemRef)
    //  });
    // })
  }

  /**
   * @brief 家族ホーム画面への移動 
   */ 
  const handleViewFamilyHome = () => {
    // this.props.history.push({ pathname: '/FamilyHome/' + this.state.FamilyID })
    navigate('/FamilyHome/' + FamilyID)
  }
  
  /** 
   * @brief 個人ホーム画面への移動
   */ 
  const handleViewPersonalHome = () => {
    // this.props.history.push({ pathname: '/PersonalHome/' + this.state.MemberID })
    navigate('/PersonalHome/' + MemberID)
  }


  /* ***************************************************************
   * 症状カード画面から各種情報の登録,更新,削除モーダルを展開する関数群.
   * 
   * 挙動的にはsymptomcard画面にリダイレクトし,
   * 遷移時のURLに付与した「viwe=XXX」の情報によって展開するモーダルを制御
   * *************************************************************** */

  /**
   * 新規登録用のモーダルを展開
   * @param {*} view "FollowUp"：経過情報、"Diagnosis"：診療結果、"Medicine"：お薬情報
   */
  const handleNewModalOpen = (view) =>{
    console.log("handleNewModalOpen("+view+")")
    switch(view) {
      case "FollowUp":
        //window.history.pushState(null, "経過情報 新規登録 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view)
        window.history.replaceState(null, "経過情報 新規登録 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view)
        document.title = "経過情報新規登録 - ふぁみかるくん"
        //sessionStorage.setItem('Previous_page', "/SymptomCard/"+this.state.medicalrecordid)
        setmodalShows({
          'Interview':  false,
          'FollowUp':   true,
          'Diagnosis':  false,
          'Medicine':   false,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   true,
        //     Diagnosis:  false,
        //     Medicine:   false,
        //     FamilyView: false
        //   }
        // })
        break

      case "Diagnosis":
        //window.history.pushState(null, "診察結果 新規登録 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view)
        window.history.replaceState(null, "診察結果 新規登録 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view)
        document.title = "診察結果 新規登録 - ふぁみかるくん"
        setmodalShows({
          'Interview':  false,
          'FollowUp':   false,
          'Diagnosis':  true,
          'Medicine':   false,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   false,
        //     Diagnosis:  true,
        //     Medicine:   false,
        //     FamilyView: false
        //   }
        // })
        break

      case "Medicine":
        //window.history.pushState(null, "お薬情報 新規登録 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view)
        window.history.replaceState(null, "お薬情報 新規登録 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view)
        document.title = "お薬情報 新規登録 - ふぁみかるくん"
        setmodalShows({
          'Interview':  false,
          'FollowUp':   false,
          'Diagnosis':  false,
          'Medicine':   true,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   false,
        //     Diagnosis:  false,
        //     Medicine:   true,
        //     FamilyView: false
        //   }
        // })
        break

      case "FamilyView":
        //window.history.pushState(null, `${this.state.DisplayName}の情報 - ふぁみかるくん`, "/SymptomCard/"+this.state.medicalrecordid+'?view='+view)
        window.history.replaceState(null, `${DisplayName}の情報 - ふぁみかるくん`, "/SymptomCard/"+MedicalRecordID+'?view='+view)
        document.title = `${DisplayName}の情報 - ふぁみかるくん`
        setmodalShows({
          'Interview':  false,
          'FollowUp':   false,
          'Diagnosis':  false,
          'Medicine':   false,
          'FamilyView': true,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   false,
        //     Diagnosis:  false,
        //     Medicine:   false,
        //     FamilyView: true
        //   }
        // })
        break

      default:
        break
    }
  }

  /**
   * 更新・削除用のモーダルを展開
   * @param {*} view "Interview"：問診情報、"FollowUp"：経過情報、"Diagnosis"：診療結果、"Medicine"：お薬情報
   * @param {*} docId 更新/削除対象データのDocID
   */
  const handleUpdateModalOpen = (view,docId) =>{
    console.log("handleUpdateModalOpen("+view+","+docId+")")
    switch(view) {
      case "Interview":
        //window.history.pushState(null, "問診情報 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view)
        window.history.replaceState(null, "問診情報 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view)
        document.title = "問診情報 - ふぁみかるくん"
        setmodalShows({
          'Interview':  true,
          'FollowUp':   false,
          'Diagnosis':  false,
          'Medicine':   false,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  true,
        //     FollowUp:   false,
        //     Diagnosis:  false,
        //     Medicine:   false,
        //     FamilyView: false
        //   }
        // })
        break

      case "FollowUp":
        //window.history.pushState(null, "経過情報 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view+'&data='+docId)
        window.history.replaceState(null, "経過情報 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view+'&data='+docId)
        document.title = "経過情報 - ふぁみかるくん"
        setmodalShows({
          'Interview':  false,
          'FollowUp':   true,
          'Diagnosis':  false,
          'Medicine':   false,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   true,
        //     Diagnosis:  false,
        //     Medicine:   false,
        //     FamilyView: false
        //   }
        // })
        break

      case "Diagnosis":
        //window.history.pushState(null, "診察結果 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view+'&data='+docId)
        window.history.replaceState(null, "診察結果 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view+'&data='+docId)
        document.title = "診察結果 - ふぁみかるくん"
        setmodalShows({
          'Interview':  false,
          'FollowUp':   false,
          'Diagnosis':  true,
          'Medicine':   false,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   false,
        //     Diagnosis:  true,
        //     Medicine:   false,
        //     FamilyView: false
        //   }
        // })
        break

      case "Medicine":
        //window.history.pushState(null, "お薬情報 - ふぁみかるくん", "/SymptomCard/"+this.state.medicalrecordid+'?view='+view+'&data='+docId)
        window.history.replaceState(null, "お薬情報 - ふぁみかるくん", "/SymptomCard/"+MedicalRecordID+'?view='+view+'&data='+docId)
        document.title = "お薬情報 - ふぁみかるくん"
        setmodalShows({
          'Interview':  false,
          'FollowUp':   false,
          'Diagnosis':  false,
          'Medicine':   true,
          'FamilyView': false,
        })
        // this.setState({
        //   modalShows: {
        //     Interview:  false,
        //     FollowUp:   false,
        //     Diagnosis:  false,
        //     Medicine:   true,
        //     FamilyView: false
        //   }
        // })
        break

      default:
        break
    }
  }
  /**
   * 各種モーダルを閉じる
   */
  const handleModalClose = () => {
    //window.history.pushState(null, `ふぁみかるくん`, "/SymptomCard/"+this.state.medicalrecordid)
    window.history.replaceState(null, `ふぁみかるくん`, "/SymptomCard/"+MedicalRecordID)
    document.title = `ふぁみかるくん`
    setmodalShows({
      'Interview':  false,
      'FollowUp':   false,
      'Diagnosis':  false,
      'Medicine':   false,
      'FamilyView': false,
    })
    // this.setState({
    //   modalShows: { 
    //     Interview:  false,
    //     FollowUp:   false,
    //     Diagnosis:  false,
    //     Medicine:   false,
    //     FamilyView: false
    //   }
    // })
  }

  /**
   * モーダル画面を閉じて、画面データをリロードする。
   */
  const handleReloadModalClose = async() => {
    console.log('handleReloadModalClose(): start')
    // window.history.pushState(null, `ふぁみかるくん`, "/SymptomCard/"+MedicalRecordID)
    navigate(`/SymptomCard/${MedicalRecordID}`, { replace: true })
    document.title = `ふぁみかるくん`
    FollowupList.list = []
    MedicalResultList.list = []
    MedicineList.list = []
    setmodalShows({
      'Interview':  false,
      'FollowUp':   false,
      'Diagnosis':  false,
      'Medicine':   false,
      'FamilyView': false,
    })
    setFollowupList(FollowupList.list)           // 経過情報リストを一度空の状態にする
    setMedicalResultList(MedicalResultList.list) // 診察結果リストを一度空の状態にする
    setMedicineList(MedicineList.list)           // お薬情報リストを一度空の状態にする
    await getMedicalRecord(firebase.firestore())
    console.log('handleReloadModalClose(): finish')
  }

  /**
   * 診療情報に削除フラグを付与して、個人ホーム画面に移動する
   */
  const handleDeleteButtonClick = () => {
    let recode_Delete_check = window.confirm('受診・症状の記録を全て削除しますか？')
    if(recode_Delete_check) {
      firebase.firestore().collection("MedicalRecords").doc(MedicalRecordID).update({
        UpdateTime: new Date(), //診療情報更新日時
        DeleteFlag: true,       //削除フラグを付与
      })
      .then(()=>{
        alert('受診・症状の記録を削除しました。')
        handleViewPersonalHome() //個人ホーム画面へ移動する。
      })
      .catch((error)=>{
        alert('受診・症状の記録削除に失敗しました。\n' + error)
      })
    } else {
      alert('削除をキャンセルしました。')
    }
  }
  /* モーダル制御用処理 ここまで *******************************************/

  return (
    <React.Fragment>
      <div>
        <FamikarHeader uid={Uid} FamilyID={FamilyID} />
        <Grid container alignItems="center" style={{padding: "10px 8px 10px"}}>
          <Grid item xs={9} style={{textAlign: "left"}}>
            <h5 style={{margin: "0px auto"}}>
              <span style={{textDecoration: "underline"}}>
                {(DisplayName !== '') ? `${DisplayName}` : ''}
              </span>
            </h5>
          </Grid>
          <Grid item xs={3} style={{textAlign: "right"}}>
            <Button style={{margin: "0px 0px", padding: "6px 12px"}} variant="outlined" color="primary" onClick={()=>handleNewModalOpen('FamilyView')}>基本情報</Button>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-start" alignItems="baseline" style={{padding: "8px 8px 0", fontSize: '1.15em'}}>
          <Grid item style={{width: "10em", textAlign: "left", fontWeight: "bold"}}> {/* 問診票作成日時 */}
            { CreateTime.getFullYear() + '/' + (CreateTime.getMonth()+1).toString().padStart(2, '0') + '/' +
              CreateTime.getDate().toString().padStart(2, '0') + ' (' + ["日", "月", "火", "水", "木", "金", "土"][CreateTime.getDay()] + ')' }
          </Grid>
          <Grid item style={{minWidth: "2em", maxWidth: "100%", fontWeight: "bold"}}> {/* 受診理由 */}
            <Grid container justifyContent="center">
              <Grid item style={{textAlign: "left"}}>{RecordTitle}</Grid>
            </Grid>
          </Grid>
          {/* //受診医療機関 は非表示扱いにする 2021/08/14 高橋
          <Grid item sm style={{minWidth: "7.5em", maxWidth: "100%", fontWeight: "bold"}}> 
            <Grid container justifyContent={String(hospitalName + RecordTitle).length <= 12 ? 'flex-end' : 'flex-start'}>
              <Grid item style={{textAlign: "left"}}>{hospitalName}</Grid>
            </Grid>
          </Grid>
          */}
        </Grid>
        {/*<Grid item xs={12} justifyContent="space-between">*/}
        <Grid container spacing={0} justifyContent="space-between" style={{padding: "8px 8px 8px"}}>
          <Grid item>
            <Button style={{margin: "0px auto", padding: "4px 0.8rem", backgroundColor: "#cfe2f3"}} variant="contained" onClick={()=>handleNewModalOpen('Diagnosis')}>
              ＋<img src={DiagnosisImg} alt="診断" style={{height: "calc(1rem + 16px)"}} />&nbsp;診断
            </Button>
          </Grid>
          <Grid item>
            <Button style={{margin: "0px auto", padding: "4px 0.8rem", backgroundColor: "#fce5cd"}} variant="contained" onClick={()=>handleNewModalOpen('Medicine')}>
              ＋<img src={MedicineImg} alt="お薬" style={{height: "calc(1rem + 16px)"}} />&nbsp;お薬
            </Button>
          </Grid>
          <Grid item>
            <Button style={{margin: "0px auto", padding: "4px 0.8rem", backgroundColor: "#f4cccc"}} variant="contained" onClick={()=>handleNewModalOpen('FollowUp')}>
              ＋<img src={FollowupImg} alt="経過" style={{height: "calc(1rem + 16px)"}} />&nbsp;経過
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ListGroup as="ul">
            {(() => {
              console.log('medicalRecordList() start!!')
              const medicalRecordList = [] /* 症状カード画面に表示する診療情報一覧 */
              // console.log(`SymptomCard.js this.state.followupList = ${JSON.stringify(followupList,null,'\t')}`)
              followupList.forEach((followup) => {
                // console.log(`SymptomCard.js followup: ${followup}`)
                let CreateTime           = new Date(followup.CreateTime.toDate())
                let followup_CreateTime  = CreateTime.getFullYear() + ('0' + (CreateTime.getMonth() + 1)).slice(-2) + ('0' + CreateTime.getDate()).slice(-2) +
                                          ('0' + CreateTime.getHours()).slice(-2) + ('0' + CreateTime.getMinutes()).slice(-2) + ('0' + CreateTime.getSeconds()).slice(-2)
                let followup_CreateTime2 = `${CreateTime.getFullYear()}/${('0' + (CreateTime.getMonth() + 1)).slice(-2)}/${('0' + CreateTime.getDate()).slice(-2)} ` +
                                          ` (${["日", "月", "火", "水", "木", "金", "土"][CreateTime.getDay()]}) ${('0' + CreateTime.getHours()).slice(-2)}:${('0' + CreateTime.getMinutes()).slice(-2)}`
                let followupID           = (followup_CreateTime === followup.id) ? followup.id : followup_CreateTime
                // console.log("followup.id: " + followup.id + ", followupID: " + followupID)
                
                //問診情報登録時に作製される初回の経過情報を症状カード画面で非表示にする。
                if (followup.id !== First_FollowUp.split('/')[3]) {
                  medicalRecordList.push(
                    <ListGroup.Item as="li" style={{padding: '0 0', margin: '0.25rem 0'}} className="justify-md-left align-left" key={followupID}>
                      <VariousRecord 
                        symptomClass          = "FollowUp"
                        registeredDate        = {followup_CreateTime2}
                        symptomContent        = {'熱：' + Number(followup.BodyTemperature).toFixed(1) + "℃"}
                        symptomNote           = {'メモ：' + followup.Note}
                        MedicalRecordID       = {MedicalRecordID}
                        uid                   = {Uid}
                        FamilyID              = {FamilyID}
                        MemberID              = {MemberID}
                        member_url            = {Member_url}
                        thum_url              = {followup.thum_url}
                        record                = {record}
                        DocID                 = {followup.id}
                        handleUpdateModalOpen = {()=>handleUpdateModalOpen("FollowUp",followup.id)}
                      />
                    </ListGroup.Item>
                  )
                }
              })
              // console.log(`add followupList to medicalRecordList : ${medicalRecordList}`);
              // console.log(...medicalRecordList)
          
              // 診断結果を診療情報一覧に追加
              // console.log(`SymptomCard.js medicalResultList = ${JSON.stringify(medicalResultList,null,'\t')}`);
              medicalResultList.forEach((medicalResult) => {
                let CreateTime                = new Date(medicalResult.CreateTime.toDate())
                let medicalResult_CreateTime  = CreateTime.getFullYear() + ('0' + (CreateTime.getMonth() + 1)).slice(-2) + ('0' + CreateTime.getDate()).slice(-2) +
                                                ('0' + CreateTime.getHours()).slice(-2) + ('0' + CreateTime.getMinutes()).slice(-2) + ('0' + CreateTime.getSeconds()).slice(-2)
                let medicalResult_CreateTime2 = `${CreateTime.getFullYear()}/${('0' + (CreateTime.getMonth() + 1)).slice(-2)}/${('0' + CreateTime.getDate()).slice(-2)} ` +
                                                ` (${["日", "月", "火", "水", "木", "金", "土"][CreateTime.getDay()]}) ${('0' + CreateTime.getHours()).slice(-2)}:${('0' + CreateTime.getMinutes()).slice(-2)}`
                let medicalResultID           = (medicalResult_CreateTime === medicalResult.id) ? medicalResult.id : medicalResult_CreateTime
                // console.log("medicalResult.id: " + medicalResult.id + ", medicalResultID: " + medicalResultID)
                medicalRecordList.push(
                  <ListGroup.Item as="li" style={{padding: '0 0', margin: '0.25rem 0'}} className="justify-md-left align-left" key={medicalResultID}>
                    <VariousRecord 
                      symptomClass          = "Diagnosis"
                      registeredDate        = {medicalResult_CreateTime2}
                      /* symptomContent        = {medicalResult.Diagnosis} */
                      symptomContent        = {'病院名：' + medicalResult.HospitalName + ' ' + medicalResult.MedicalSpecialty}
                      /* symptomNote           = {'メモ：' + medicalResult.Instructions} */ /* 先生からの指示を出力 */
                      symptomNote           = {'メモ：' + medicalResult.Note}
                      MedicalRecordID       = {MedicalRecordID}
                      uid                   = {Uid}
                      FamilyID              = {FamilyID}
                      MemberID              = {MemberID}
                      member_url            = {Member_url}
                      thum_url              = {medicalResult.thum_url}
                      record                = {record}
                      DocID                 = {medicalResult.id}
                      handleUpdateModalOpen = {()=>handleUpdateModalOpen("Diagnosis",medicalResult.id)}
                    />
                  </ListGroup.Item>
                )
              })
              // console.log(`add medicalResult to medicalRecordList : ${medicalRecordList}`);

              // お薬情報を診療情報一覧に追加
              // console.log(`SymptomCard.js medicineList = ${JSON.stringify(medicineList,null,'\t')}`);
              medicineList.forEach((medicine) => {
                let CreateTime           = new Date(medicine.CreateTime.toDate())
                let medicine_CreateTime  = CreateTime.getFullYear() + ('0' + (CreateTime.getMonth() + 1)).slice(-2) + ('0' + CreateTime.getDate()).slice(-2) +
                                           ('0' + CreateTime.getHours()).slice(-2) + ('0' + CreateTime.getMinutes()).slice(-2) + ('0' + CreateTime.getSeconds()).slice(-2)
                let medicine_CreateTime2 = `${CreateTime.getFullYear()}/${('0' + (CreateTime.getMonth() + 1)).slice(-2)}/${('0' + CreateTime.getDate()).slice(-2)} ` +
                                           ` (${["日", "月", "火", "水", "木", "金", "土"][CreateTime.getDay()]}) ${('0' + CreateTime.getHours()).slice(-2)}:${('0' + CreateTime.getMinutes()).slice(-2)}`
                let medicineID           = (medicine_CreateTime === medicine.id) ? medicine.id : medicine_CreateTime
                // console.log("medicine.id: " + medicine.id + ", medicineID: " + medicineID)
                medicalRecordList.push(
                 <ListGroup.Item as="li" style={{padding: '0 0', margin: '0.25rem 0'}} className="justify-md-left align-left" key={medicineID} >
                   <VariousRecord 
                     symptomClass          = "Medicine"
                     registeredDate        = {medicine_CreateTime2}
                     /* symptomContent        = {"医療機関/薬局："+medicine.pharmacy} */
                     symptomContent        = {'メモ：' + medicine.Note}
                     symptomNote           = {'　'}
                     MedicalRecordID       = {MedicalRecordID}
                     uid                   = {Uid}
                     FamilyID              = {FamilyID}
                     MemberID              = {MemberID}
                     member_url            = {Member_url}
                     thum_url              = {medicine.thum_url}
                     record                = {record}
                     DocID                 = {medicine.id}
                     handleUpdateModalOpen = {()=>handleUpdateModalOpen("Medicine",medicine.id)}
                   />
                 </ListGroup.Item>
                )
              })
              // console.log(`add medicine to medicalRecordList : ${medicalRecordList}`);
    
              // 診療情報一覧をCreateTimeでソート（最新のデータが先頭にくる）
              medicalRecordList.sort((a,b) => {
                if( a.key > b.key ){
                  return -1
                } else {
                  return 1
                }
              })
              //console.log(`sort medicalRecordList by date : ${medicalRecordList}`);
              //console.log(`sort medicalRecordList by date : ${JSON.stringify(medicalRecordList,null,'\t')}`);
              
              // let CreateTime            = CreateTime
              // let UpdateTime            = UpdateTime
              let InterviewID           = MedicalRecordID.split('_')[1]
              let interview_CreateTime  = CreateTime.getFullYear() + ('0' + (CreateTime.getMonth() + 1)).slice(-2) + ('0' + CreateTime.getDate()).slice(-2) +
                                          ('0' + CreateTime.getHours()).slice(-2) + ('0' + CreateTime.getMinutes()).slice(-2) + ('0' + CreateTime.getSeconds()).slice(-2)
              let interview_CreateTime2 = `${CreateTime.getFullYear()}/${('0' + (CreateTime.getMonth() + 1)).slice(-2)}/${('0' + CreateTime.getDate()).slice(-2)} ` +
                                          ` (${["日", "月", "火", "水", "木", "金", "土"][CreateTime.getDay()]}) ${('0' + CreateTime.getHours()).slice(-2)}:${('0' + CreateTime.getMinutes()).slice(-2)}`
              let interview_UpdateTime  = UpdateTime.getFullYear() + ('0' + (UpdateTime.getMonth() + 1)).slice(-2) + ('0' + UpdateTime.getDate()).slice(-2) +
                                          ('0' + UpdateTime.getHours()).slice(-2) + ('0' + UpdateTime.getMinutes()).slice(-2) + ('0' + UpdateTime.getSeconds()).slice(-2)
              InterviewID               = (interview_CreateTime === InterviewID) ? InterviewID : interview_CreateTime
              InterviewID               = InterviewID + '_' + interview_UpdateTime
              
              //console.log("InterviewID: " + InterviewID)
              //console.log('this.state.Fever_Degrees: ' + Number(this.state.Fever_Degrees).toFixed(1))
              medicalRecordList.unshift(
                <ListGroup.Item as="li" style={{padding: '0 0', margin: '0.25rem 0'}} className="justify-md-left align-left" key={InterviewID}>
                  <VariousRecord 
                    symptomClass          = "Interview"
                    registeredDate        = {interview_CreateTime2}
                    symptomContent        = {'熱：' + Number(Fever_Degrees).toFixed(1) + '℃'}
                    symptomNote           = {'メモ：' + Note}
                    MedicalRecordID       = {MedicalRecordID}
                    uid                   = {Uid}
                    FamilyID              = {FamilyID}
                    MemberID              = {MemberID}
                    member_url            = {Member_url}
                    record                = {record}
                    handleUpdateModalOpen = {()=>handleUpdateModalOpen("Interview",'')}
                  />
                </ListGroup.Item>
              )
              //console.log('medicalRecordList add Interview this.state.Fever_Degrees: ' + Number(this.state.Fever_Degrees).toFixed(1))
              return medicalRecordList
            })()}
          </ListGroup>
          {/* {console.log(`medicalRecordList: [${medicalRecordList}]`)} */}
        </Grid>
        <Toolbar />
        <AppBar position="fixed" style={{backgroundColor: '#FFFFFF', top: 'auto', bottom: '0', boxShadow: 'none'}}>
          <Grid container justifyContent="space-between" alignItems="flex-start" style={{padding: '16px 8px 8px', maxWidth: '480px'}} className="App">
            <Button variant="contained" color="secondary" onClick={()=>handleDeleteButtonClick()}>削除</Button>
            <Button variant="contained" color="primary"   onClick={()=>handleViewPersonalHome()}>戻る</Button>
            {/*
            <Tooltip title="戻る">
              <IconButton variant="outline-primary" size="medium" onClick={()=>handleGoBack()}>
                <KeyReturnIcon />
              </IconButton>
            </Tooltip>
            */}
          </Grid>
        </AppBar>
      </div>
      {/* Modal */}
      <div>
        {/* {console.log(`modalShows: ${JSON.stringify(modalShows,null,'\t')}`)} */}
        <Modal open={modalShows.Interview} onClose={()=>handleModalClose()} className={classes.modal}>
          <Fade in={modalShows.Interview}>
            <div className={classes.paper}>
              <ModalInterview handleModalClose={()=>handleModalClose()} handleReloadModalClose={()=>handleReloadModalClose()} className={classes.float}
                MedicalRecord_ID={MedicalRecordID} DisplayName={DisplayName} uid={Uid} FamilyID={FamilyID}
                MemberID={MemberID} member_url={Member_url} Interview_state='Edit' />
            </div>
          </Fade>
        </Modal>
        <Modal open={modalShows.FollowUp} onClose={()=>handleModalClose()} className={classes.modal}>
          <Fade in={modalShows.FollowUp}>
            <div className={classes.paper}>
              <ModalFollowUp handleModalClose={()=>handleModalClose()} handleReloadModalClose={()=>handleReloadModalClose()}
                className={classes.float} MedicalRecordId={MedicalRecordID} DisplayName={DisplayName} />
            </div>
          </Fade>
        </Modal>
        <Modal open={modalShows.Diagnosis} onClose={()=>handleModalClose()} className={classes.modal}>
          <Fade in={modalShows.Diagnosis}>
            <div className={classes.paper}>
              <ModalDiagnosis handleModalClose={()=>handleModalClose()} handleReloadModalClose={()=>handleReloadModalClose()}
                className={classes.float} MedicalRecordId={MedicalRecordID} DisplayName={DisplayName} />
            </div>
          </Fade>
        </Modal>
        <Modal open={modalShows.Medicine} onClose={()=>handleModalClose()} className={classes.modal}>
          <Fade in={modalShows.Medicine}>
            <div className={classes.paper}>
              <ModalMedicine handleModalClose={()=>handleModalClose()} handleReloadModalClose={()=>handleReloadModalClose()}
                className={classes.float} MedicalRecordId={MedicalRecordID} DisplayName={DisplayName} />
            </div>
          </Fade>
        </Modal>
        <Modal open={modalShows.FamilyView} onClose={()=>handleModalClose()} className={classes.modal}>
          <Fade in={modalShows.FamilyView}>
            <div className={classes.paper}>
              <ModalFamilyView handleModalClose={()=>handleModalClose()} className={classes.float}
                DisplayName={DisplayName} image_src={Member_url} uid={Uid} FamilyID={FamilyID}
                MemberID={MemberID} MedicalRecordID={MedicalRecordID} />
            </div>
          </Fade>
        </Modal>
      </div>
    </React.Fragment>
  )
}
